<template>
    <v-app>
        <v-main>
                <v-col v-if="expired" cols="12" align="center">
                    <h1>Expired</h1>
                </v-col>
                <v-col v-else md="10" offset-md="1" cols="12" offset="0" class="py-0 px-0">
                    <clean-lessons-view :lessons="lessons" :students="students" :validity="{start_date, end_date}"/>
                </v-col>
        </v-main>
    </v-app>
</template>

<script>

import axios from 'axios'

import CleanLessonsView from '../components/teacher/CleanLessonsView.vue'

export default {
    name: 'ShareView',

    components: {
        CleanLessonsView
    },
    data () {
        return {
            lessons: [],
            students: [],
            start_date: null,
            end_date: null,
            expired: false
        }
    },
    methods: {
        async refresh_lessons () {
            try {
                var r = await axios.get(`${this.$store.getters['api/api_base']}/view/${this.$route.params.token}`);
                r.data.students.sort((a, b) => a.last_name.localeCompare(b.last_name));
                this.lessons = r.data.lessons;
                var counter = 0;
                this.students = r.data.students.map(s => Object.assign({}, s, {id: counter++}));
                this.start_date = r.data.validity.start_date;
                this.end_date = r.data.validity.end_date;
            } catch (error) {
                if (error.response.status == 401) {
                    this.$vuetify.theme.dark = true;
                    this.$router.push('/error/unauthorized');
                } else if (error.response.status == 410) {
                    this.expired = true;
                }
            }
        }
    },
    async created () {
        this.$vuetify.theme.dark = false;
        await this.refresh_lessons();
    }
};
</script>

<style>
body {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none; /* Standard syntax */
}

.selectable {
  -webkit-user-select: auto !important; /* Safari */
  -ms-user-select: auto !important; /* IE 10+ and Edge */
  user-select: auto !important; /* Standard syntax */
}

.v-item-group.v-bottom-navigation .v-btn {
    height: inherit !important;
}
</style>
